import "./App.css";
import QrComponenet from "./component/QrComponenet";

function App() {
  return (
    <>
      <QrComponenet />
    </>
  );
}

export default App;
